import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  AfterViewInit,
  OnDestroy,
  NgZone
} from '@angular/core';

@Directive({
  selector: '[appCheckFlexWrap]'
})
export class CheckFlexWrapDirective implements AfterViewInit, OnDestroy {
  @Output() flexWrapped = new EventEmitter<{
    wrapped: boolean;
    startIndex?: number;
  }>();

  private resizeObserver!: ResizeObserver;
  private lastValue: boolean | null = null;
  private checkPending = false;
  private lastIndex:any = 0;

  constructor(private el: ElementRef, private ngZone: NgZone) {}

  ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserver(() => this.scheduleWrapCheck());
      this.resizeObserver.observe(this.el.nativeElement);

      // Also listen for window resize
      window.addEventListener('resize', this.handleWindowResize);

      // Initial check
      setTimeout(() => this.checkWrap(), 100);
    });
  }

  private handleWindowResize = () => {
    this.scheduleWrapCheck();
  };

  private scheduleWrapCheck() {
    if (!this.checkPending) {
      this.checkPending = true;
      requestAnimationFrame(() => {
        setTimeout(() => {
          this.checkWrap();
          this.checkPending = false;
        }, 20); // small delay to ensure layout stabilizes
      });
    }
  }

  private checkWrap() {
    const children = Array.from(this.el.nativeElement.children) as HTMLElement[];

    if (children.length === 0) {
      this.updateValue({ wrapped: false });
      return;
    }

    const firstChildTop = children[0].offsetTop;
    let startIndex: number | undefined;

    for (let i = 1; i < children.length; i++) {
      if (children[i].offsetTop > firstChildTop) {
        startIndex = i;
        break;
      }
    }

    const isWrapped = startIndex !== undefined;
    this.updateValue({ wrapped: isWrapped, startIndex });
  }

  private updateValue(value: { wrapped: boolean; startIndex?: number }) {
    // if (this.lastValue !== value.wrapped || this.lastIndex !== value.startIndex) {
      this.lastValue = value.wrapped;
      this.lastIndex = value.startIndex;
      this.ngZone.run(() => this.flexWrapped.emit(value));
    // }
  }

  ngOnDestroy() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.handleWindowResize);
  }
}
